export const ISSUE_TRANSITION_VIEW_TYPE = 'IssueTransition' as const;
